<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-12 mt-4 d-flex justify-content-center">
            <div class="col-md-2 d-flex justify-content-end">
                <h5>{{ labels.validity }}:</h5>
            </div>
            <div class="col-md-3 d-flex justify-content-start">
                <input type="month" v-model="validity" class="form-control">
            </div>
        </div>
        <div class="col-md-12 mt-3 d-flex justify-content-center">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createCalificacion">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row col-md-12 mt-3 justify-content-center" v-if="listVigencias != 0">
            <b-table
                :items="listVigencias"
                :fields="fields"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :per-page="perPage"
                :current-page="currentPage"
                @row-clicked="(item) => editCalificacion(item.id)"
            >
                <template #cell(calificacion)="data">
                    <div class="text-left">{{ data.item.calificacion }}</div>
                </template>
                <template #cell(descripcion)="data">
                    <div class="text-left">{{ data.item.descripcion }}</div>
                </template>
                <template #cell(score)="data">
                    <div class="text-right">{{ formatNumber(data.item.score) }}</div>
                </template>
            </b-table>
            <div class="row col-md-12 mt-1">
                <div class="col-md-2 d-flex justify-content-start">
                    {{ listVigencias.length }}
                </div>
                <div class="col-md-8 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="listVigencias.length"
                    :per-page="perPage"
                    align="center"
                    size="md"
                    class="custom-pagination"
                    ></b-pagination>
                </div>
                <div class="col-md-2 d-flex justify-content-end">
                    <label class="mr-2 mb-0">Filas por página:</label>
                    <b-form-select
                    v-model="perPage"
                    :options="[5, 10, 20, 50, 100, 500]"
                    size="sm"
                    style="width: 80px;"
                    ></b-form-select>
                </div>
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modalCrear="showModCrear" :infoVigencia="validity" @cierraModal="closeModal"></Crear>
        <Editar :modalEditar="showModEditar" :infoCalificacion="listCalificacion" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import Calificacion from '../../../services/Calificacion';
import Crear from './Crear.vue';
import Editar from './Editar.vue';
export default {
    name : 'Calificacion',
    components : {Crear,Editar},
    data : () => ({
        listVigencias : [],
        showModCrear : false,
        showModEditar : false,
        listCalificacion : [],
        validity : '',
        perPage: 500,
        currentPage: 1,
        fields : [
            { key: 'calificacion', label: 'Calificación', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false },
            { key: 'score', label: 'Score', sortable: false }
        ],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Calificación',
                    validity : 'Vigencia',
                    calificacion : 'Calificación',
                    descripcion : 'Descripción',
                    score : 'Score',
                    noRow : "No hay registros",
                }
            }else{
                return {
                    title : 'Rating',
                    validity : 'Validity',
                    calificacion : 'Calification',
                    descripcion : 'Description',
                    score : 'Score',
                    noRow : "There are not records",
                }
            }
        }
    },
    methods : {
        closeModal(val){
            this.showModCrear = val
            this.showModEditar = val
        },
        createCalificacion(){
            this.showModCrear = true
        },
        editCalificacion(id){
            // console.log(id);
            Calificacion.calificacionById(id)
            .then((res) => {
                // console.log(res.data.calificacionById);
                this.listCalificacion = res.data.calificacionById
                // this.listCalificacion = res.data.calificaByVigencia
                this.showModEditar = true
            })
            .catch((err) => console.log(err))
            /*Calificacion.calificacionByVigencia(vigencia)
            .then((res) => {
                // console.log(res.data);
                this.listCalificacion = res.data.calificaByVigencia
                this.showModEditar = true
            })
            .catch((err) => console.log(err))*/
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value);
        },
    },
    mounted(){
    },
    watch:{
        validity(valNew){
            // console.log(valNew);
            let fecha = valNew+'-31'
            Calificacion.calificacionByVigencia(fecha)
            .then((res) => {
                // console.log(res.data);
                this.listVigencias = res.data.calificaByVigencia
            })
            .catch((err) => console.log(err))
        }
    }
}
</script>

<style>

</style>